import { LANG } from '../App/constants'

export const STATE_KEY = 'SkGamesValuesPage'

export const CONTENT_LOAD = 'Casino/SkGamesValues/CONTENT_LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/SkGamesValues/CONTENT_LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/SkGamesValues/CONTENT_LOAD_ERROR'

export const PLAYER_SK_GAMES_VALUES_ADDRESS = `/${LANG}/profile/bets-wins-values`
